import { useLayoutEffect, useState } from 'react'
import { acquireOverlayLayer, releaseOverlayLayer, OVERLAY_BASE_Z } from '@/utils/overlayStack'

// Layout effect so the overlay paints at its final z-index on the first frame.
export const useOverlayLayer = (isOpen: boolean): number => {
  const [zIndex, setZIndex] = useState(OVERLAY_BASE_Z)

  useLayoutEffect(() => {
    if (!isOpen) {
      return
    }
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Open/close lifecycle: the layer is claimed from a shared stack, not derived from props.
    setZIndex(acquireOverlayLayer())
    return releaseOverlayLayer
  }, [isOpen])

  return zIndex
}
